var map = {
	"./af-ZA.svg": 92356,
	"./ar-EG.svg": 26691,
	"./ar.svg": 49354,
	"./bg-BG.svg": 26378,
	"./cs.svg": 49301,
	"./de-AT.svg": 83276,
	"./de-CH.svg": 56182,
	"./de.svg": 89858,
	"./el-GR.svg": 79338,
	"./el.svg": 11240,
	"./en-AU.svg": 95285,
	"./en-NZ.svg": 42455,
	"./en-US.svg": 47055,
	"./en.svg": 50634,
	"./es-AR.svg": 62985,
	"./es-PR.svg": 87354,
	"./es.svg": 45631,
	"./et.svg": 32608,
	"./fi-FI.svg": 86478,
	"./fil-PH.svg": 81253,
	"./fr-CH.svg": 25889,
	"./fr.svg": 79015,
	"./he-IL.svg": 93760,
	"./hu.svg": 91518,
	"./it-IT.svg": 69962,
	"./it.svg": 51724,
	"./lt.svg": 2267,
	"./lv.svg": 86297,
	"./pl.svg": 16735,
	"./pt-BR.svg": 48252,
	"./pt.svg": 2151,
	"./ro-RO.svg": 78234,
	"./ro.svg": 8726,
	"./ru.svg": 89708,
	"./sk-SK.svg": 2796,
	"./sk.svg": 14301,
	"./sr.svg": 54468,
	"assets/images/flags/af-ZA.svg": 92356,
	"assets/images/flags/ar-EG.svg": 26691,
	"assets/images/flags/ar.svg": 49354,
	"assets/images/flags/bg-BG.svg": 26378,
	"assets/images/flags/cs.svg": 49301,
	"assets/images/flags/de-AT.svg": 83276,
	"assets/images/flags/de-CH.svg": 56182,
	"assets/images/flags/de.svg": 89858,
	"assets/images/flags/el-GR.svg": 79338,
	"assets/images/flags/el.svg": 11240,
	"assets/images/flags/en-AU.svg": 95285,
	"assets/images/flags/en-NZ.svg": 42455,
	"assets/images/flags/en-US.svg": 47055,
	"assets/images/flags/en.svg": 50634,
	"assets/images/flags/es-AR.svg": 62985,
	"assets/images/flags/es-PR.svg": 87354,
	"assets/images/flags/es.svg": 45631,
	"assets/images/flags/et.svg": 32608,
	"assets/images/flags/fi-FI.svg": 86478,
	"assets/images/flags/fil-PH.svg": 81253,
	"assets/images/flags/fr-CH.svg": 25889,
	"assets/images/flags/fr.svg": 79015,
	"assets/images/flags/he-IL.svg": 93760,
	"assets/images/flags/hu.svg": 91518,
	"assets/images/flags/it-IT.svg": 69962,
	"assets/images/flags/it.svg": 51724,
	"assets/images/flags/lt.svg": 2267,
	"assets/images/flags/lv.svg": 86297,
	"assets/images/flags/pl.svg": 16735,
	"assets/images/flags/pt-BR.svg": 48252,
	"assets/images/flags/pt.svg": 2151,
	"assets/images/flags/ro-RO.svg": 78234,
	"assets/images/flags/ro.svg": 8726,
	"assets/images/flags/ru.svg": 89708,
	"assets/images/flags/sk-SK.svg": 2796,
	"assets/images/flags/sk.svg": 14301,
	"assets/images/flags/sr.svg": 54468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63492;